import { useId } from 'react';

export function Field({
    label, name, values, setValues, multiline = false, ...props
}) {
    const fieldId = useId();
    const fieldProps = {
        id: fieldId,
        name,
        value: values[name] ?? '',
        onChange: (event) => setValues((previous) => ({ ...previous, [name]: event.target.value })),
        ...props,
    };
    return (
        <label
            className="po-field"
            htmlFor={fieldId}>
            <span>{label}</span>
            {multiline ? (
                <textarea
                    {...fieldProps}
                    rows={3} />
            ) : (
                <input {...fieldProps} />
            )}
        </label>
    );
}
export const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
export const defaultInstructions = 'Please make checks payable to RBliss, LLC and mail to PO Box 24, Santa Margarita, CA 93453. Please include the invoice number and purchase order number with payment.';
